class DeviceApproval {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.deviceApprovalCheckbox();
    }
    deviceApprovalCheckbox(){
        let thisClass = this;
        let checkbox = document.getElementById('deviceApprovalEnabledCheckbox');
        if(checkbox){
            checkbox.addEventListener('change', (event) => {
                event.preventDefault();
                if (event.currentTarget.disabled === false) {
                    let swalText;
                    let checked = event.currentTarget.checked;
                    if (!checked) {
                        swalText = `Are you sure you want to <b>disable</b> Device Approval?<div class="alert alert-danger d-flex align-items-center mt-5 mx-0">
                            <div class="d-flex flex-column fs-6 text-start">
                                <span>Disabling Device Approval deletes all devices awaiting approval and all denied devices. These devices gain access to the perimeter!</span>
                            </div>
                            </div>
                            <div class="form-check mt-5">
                                <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                                <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                                    I agree
                                </label>
                            </div>`;
                    } else {
                        swalText = `Are you sure you want to <b>enable</b> Device Approval?
                            <div class="alert alert-danger d-flex align-items-center mt-5 mx-0">
                                <div class="d-flex flex-column fs-6 text-start">
                                    <span>To ensure full functionality of this feature, no one with a GoodAccess application version older than <strong>4.5.0</strong> will not be able to log in!</span>
                                </div>
                            </div>
                            <div class="form-check mt-5">
                                <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                                <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                                    I agree
                                </label>
                            </div>`;
                    }
                    Swal.fire({
                        html: `<span class="text-primary">${swalText}</span>`,
                        icon: "warning",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        reverseButtons: true,
                        showCancelButton: true,
                        confirmButtonText: "Save changes",
                        customClass: {
                            confirmButton: "btn btn-danger mt-0",
                            cancelButton: 'btn btn-light-primary mt-0',
                        },
                        showLoaderOnConfirm: true,
                        returnFocus: false,
                        preConfirm: () => {
                            let deleteGatewaySwalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                            if(deleteGatewaySwalCheckbox && !deleteGatewaySwalCheckbox.checked){
                                Swal.showValidationMessage(`You need to agree`);
                                return;
                            }

                            return fetch('/device-approval?do=changeDeviceApproval&organizationID='+thisClass.organizationID+'&result='+(checked ? 1 : 0))
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error(response.statusText)
                                    }
                                    return response.json();
                                }).catch(error => {
                                    Swal.showValidationMessage(`Request failed: ${error}`)
                                });
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                        allowEscapeKey: () => !Swal.isLoading()
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if(result.value === true){
                                let badge = document.getElementById('device-approval-status-badge');
                                if(checked){
                                    badge.classList.remove('badge-danger');
                                    badge.classList.add('badge-success');
                                    badge.innerText = 'Active';
                                    toastr.success('Device Approval has been successfully enabled!');

                                    const numberOfAwaitingDevices = $('#devices-awaiting-approval-datatable').DataTable().page.info().recordsTotal;
                                    thisClass.updateNumberOfAwaitingDevices(numberOfAwaitingDevices);
                                } else {
                                    badge.classList.remove('badge-success');
                                    badge.classList.add('badge-danger');
                                    badge.innerText = 'Inactive';
                                    toastr.success('Device Approval has been successfully disabled!');

                                    thisClass.updateNumberOfAwaitingDevices(0);

                                    $('#devices-awaiting-approval-datatable').DataTable().ajax.reload(null, false);
                                    $('#denied-devices-datatable').DataTable().ajax.reload(null, false);
                                }
                            }
                        } else {
                            checkbox.checked = !checked;
                        }
                    });
                }
            });
        }
    }
    updateNumberOfAwaitingDevices(numberOfAwaitingDevices){
        const numberOfAwaitingDevicesEl = document.querySelectorAll('.number-of-awaiting-devices');
        numberOfAwaitingDevicesEl.forEach(function(el) {
            if(numberOfAwaitingDevices === 0){
                el.innerHTML = '';
            } else {
                el.innerHTML = numberOfAwaitingDevices;
            }
        });
    }
}
window.DeviceApproval = DeviceApproval;